export enum TermUseType {
    SERVICE_BOAT_CONTRACT = 'SERVICE_BOAT_CONTRACT'
}